export default __webpack_public_path__ + "static/media/img_7.abb3da75.jpg";